import { createSelector, createSlice } from '@reduxjs/toolkit';
import { keyBy } from 'lodash';
import { addItemsToList, sar } from '../../../helpers/reduxHelper';
import { selectAllLinkedObjects } from './configuratorSceneLabels.slicer';

const getInitialState = () => ({
  selectedObjects: [],
  selectedBackupObjects: [],
  propTree: [],
  isTransformationPanelMinimize: true,
});

const configuratorUnityObject = createSlice({
  name: 'configuratorUnityObject',
  initialState: getInitialState(),
  reducers: {
    resetState: () => {
      return getInitialState();
    },
    setSelectedObjects: sar('selectedObjects'),
    setSelectedBackupObjects: sar('selectedBackupObjects'),
    setPropTree: sar('propTree'),
    addPropToTree: addItemsToList('propTree'),
    updateObjectTransform: (state, { payload }) => {
      const { id, transformData } = payload;
      state.selectedObjects = state.selectedObjects.map((o) => {
        return o.id !== id
          ? o
          : {
              ...o,
              newTransformData: {
                ...o.newTransformData,
                ...transformData,
              },
            };
      });
    },
    syncObjectTransform: (state, { payload }) => {
      const { transformData } = payload;
      const map = keyBy(transformData, (o) => o.ObjectName);
      state.selectedObjects = state.selectedObjects.map((o) => {
        const newTransformData = map[o.objectName];
        if (newTransformData) {
          return {
            ...o,
            newTransformData,
          };
        }
        return 0;
      });
    },
    toggleTransformationPanel: (state, { payload }) => {
      state.isTransformationPanelMinimize = payload;
    },
  },
});

export const configuratorUnityObjectActions = configuratorUnityObject.actions;

export const configuratorUnityObjectSelector = (state) => state.configuratorUnityObject;

export const configuratorUnityObjectReducer = configuratorUnityObject.reducer;

export default configuratorUnityObjectReducer;

export const selectSelectedBackupObjects = (state) =>
  state.configuratorUnityObject.selectedBackupObjects;

export const selectSelectedObjects = (state) => state.configuratorUnityObject.selectedObjects;

export const selectHasOneObjectSelected = (state) =>
  state.configuratorUnityObject.selectedObjects.length === 1;

export const selectHasSelectedObject = (state) =>
  state.configuratorUnityObject.selectedObjects.length > 0;

export const selectCanApplyMTC = (state) =>
  state.configuratorUnityObject.selectedObjects.length > 0;

export const selectMultipleObjectsSelected = (state) =>
  state.configuratorUnityObject.selectedObjects.length > 1;

export const selectPropTree = (state) => state.configuratorUnityObject.propTree;

export const selectPropFlatList = (state) => {
  const tree = selectPropTree(state);
  return tree;
};

export const selectIsTransformPanelMinimize = (state) =>
  state.configuratorUnityObject.isTransformationPanelMinimize;

export const selectCurrentSceneUnlinkedObjects = createSelector(
  (state) => selectAllLinkedObjects(state),
  (state) => selectPropFlatList(state),
  (linkedObjects, allObjects) => {
    const unlinkedObjects = allObjects.filter(
      (a) => !linkedObjects.map((b) => b.objectName).includes(a.objectName)
    );
    return unlinkedObjects;
  }
);
